import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Insurance } from 'src/app/margin-calculator/models/insurance.model';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';
import { combine } from 'src/app/shared/utilities/route';
import { MarginInsuranceEffectiveDates } from '../models/insurance-margin-effective-dates.model';
import { MarginStateInsuranceEffectiveDates } from '../models/insurance-margin-state-effective-dates.model';
import { InsuranceRequest } from '../models/insurance-request.model';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';

export enum InsuranceTypes {
    DENTAL = 'Dental/Vision/Life',
    MEDICAL = 'Medical'
}

export enum InsuranceBenefitTypes {
    NewBenefits = 1,
    Extension,
    Ineligible,
    NoBenefits
}

export enum InsuranceIneligibleReasonTypes {
    LessThan30DayBreakInEmployment = 1,
    WeeklyHoursLessThanMinimumRequired,
    InsuranceUnavailableForState
}

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorInsuranceService extends MarginCalculatorBaseService {
    endDateInitiallyLoaded = false;
    clinicianInitiallyLoaded = false;

    constructor(private _httpClient: HttpClient) {
        super();
    }

    getBenefitsCosts(): Observable<Insurance[]> {
        return this._httpClient.get<Insurance[]>(`${this.coreApiPath}/margin-calculator/benefits`);
    }

    getBenefitsInfo(request: InsuranceRequest): Observable<Insurance> {
        const url = combine(this.coreApiPath, 'margin-calculator/insurance-benefits');
        const params = interpolateParams(request);
        return this._httpClient.get<Insurance>(url, { params });
    }

    getPreviouslyEnrolled(previousContract): boolean {
        if (previousContract?.lastEnrollmentDate) {
            return previousContract?.lastEnrollmentDate?.length > 0;
        } else {
            return false;
        }
    }

    getMarginInsuranceNewEffectiveDate(): Observable<Date> {
        return this._httpClient.get<Date>(`${this.coreApiPath}/margin-calculator/margin-insurance-new-effective-date`);
    }

    getMarginInsuranceEffectiveDates(): Observable<MarginInsuranceEffectiveDates> {
        return this._httpClient.get<MarginInsuranceEffectiveDates>(
            `${this.coreApiPath}/margin-calculator/margin-insurance-effective-dates`
        );
    }

    getMarginStateInsuranceEffectiveDates(): Observable<MarginStateInsuranceEffectiveDates> {
        return this._httpClient.get<MarginStateInsuranceEffectiveDates>(
            `${this.coreApiPath}/margin-calculator/margin-insurance-effective-dates`
        );
    }
}
